import React, { useLayoutEffect, useRef } from 'react';

import TrendingTop from '@publicImages/svg/trending-top.svg?static';

import { useUIResource } from '@/ducks/common/resources';

import styles from './PromotionTrending.module.scss';

const SHORT_TEXT_THRESHOLD = 9;

const PromotionTrending: React.FC = () => {
  const text = useUIResource('Trending.ItineraryResults');
  const isShortText = text.length < SHORT_TEXT_THRESHOLD;
  const firstAnimatedRef = useRef<HTMLDivElement>(null);
  const secondAnimatedRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (isShortText) return;

    const timer = setTimeout(() => {
      if (firstAnimatedRef.current) {
        firstAnimatedRef.current.classList.add(styles.animate);
      }
      if (secondAnimatedRef.current) {
        secondAnimatedRef.current.classList.add(styles.animate);
      }
    }, 50);

    return () => clearTimeout(timer);
  }, [isShortText]);

  return (
    <div className={styles.root}>
      <TrendingTop />

      <div className={styles.content}>
        <span className={styles.star}>★</span>
        {isShortText ? (
          <span className={styles.textStatic}>{text}</span>
        ) : (
          <div className={styles.textAnimated}>
            <div className={styles.textAnimatedContent} ref={firstAnimatedRef}>
              {text}
            </div>
            <div aria-hidden className={styles.textAnimatedContent} ref={secondAnimatedRef}>
              {text}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PromotionTrending;
